import { useEffect, useRef, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import BusinessCards from "@/pages/BusinessCards";
import Admin from "@/pages/Admin";
import EWasteRecycling from "@/pages/EWasteRecycling";
import MinorMetals from "@/pages/MinorMetals";

function CustomCursor() {
  const dot = useRef(null);
  const [hovering, setHovering] = useState(false);

  useEffect(() => {
    const move = (e) => {
      if (dot.current) {
        dot.current.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`;
      }
    };
    const over = (e) => {
      setHovering(!!e.target.closest("[data-cursor='view'], a, button"));
    };
    window.addEventListener("mousemove", move);
    window.addEventListener("mouseover", over);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("mouseover", over);
    };
  }, []);

  return (
    <div
      ref={dot}
      aria-hidden
      className="pointer-events-none fixed left-0 top-0 z-[70] hidden md:block"
      style={{ transition: "opacity 0.2s" }}
    >
      <div
        className="-translate-x-1/2 -translate-y-1/2 rounded-full border border-[#C2551F] bg-[#C2551F]/10 transition-[width,height] duration-200"
        style={{
          width: hovering ? 46 : 10,
          height: hovering ? 46 : 10,
        }}
      />
    </div>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.4,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App bg-[var(--mx-bg)] text-[var(--mx-ink)]">
      <div className="grain" aria-hidden />
      <img
        src="/metalix-mark.png"
        alt=""
        aria-hidden
        data-testid="logo-watermark"
        className="pointer-events-none fixed left-1/2 top-1/2 z-[45] w-[min(72vw,760px)] -translate-x-1/2 -translate-y-1/2 opacity-[0.06]"
      />
      <CustomCursor />
      <Toaster
        theme="light"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#ffffff",
            border: "1px solid rgba(27,23,20,0.12)",
            color: "#1b1714",
            borderRadius: 0,
            fontFamily: "IBM Plex Mono, monospace",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/cards" element={<BusinessCards />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/e-waste-recycling" element={<EWasteRecycling />} />
          <Route path="/minor-metals" element={<MinorMetals />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
